module.exports = __webpack_public_path__ + "static/img/brief_1.9d059be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/brief_1.jpg
// module id = nDZ3
// module chunks = 1